import { translations } from './translations';
import { SupportedLanguage } from '@immosky/types';

const supportedLanguages = Object.keys(translations);

export function getNavigatorLanguage(
  fallback: SupportedLanguage = 'de'
): SupportedLanguage {
  return getClosestSupportedLanguage(navigator.language.substr(0, 2), fallback);
}

export function getClosestSupportedLanguage(
  lang: string,
  fallback: SupportedLanguage = 'de'
): SupportedLanguage {
  if (!lang) {
    return fallback;
  }

  const exactMatch = supportedLanguages.find((l) => l === lang);

  if (exactMatch) {
    return exactMatch as SupportedLanguage;
  }

  return fallback;
}
